import { FeatureMockFrame } from './FeatureMockFrame';
import type { FeatureMockSize } from './FeatureMockFrame';

export const PRIVATE_REQUEST_MOCK_ALT =
  'CourtSync private lesson request inbox showing a guardian package request and owner approval';

interface PrivateRequestMockProps {
  size?: FeatureMockSize;
  className?: string;
}

export function PrivateRequestMock({ size = 'compact', className }: PrivateRequestMockProps) {
  return (
    <FeatureMockFrame
      id="private-requests"
      alt={PRIVATE_REQUEST_MOCK_ALT}
      size={size}
      className={className}
    >
      <div className="csm-private">
        <div className="csm-private-header">Private lesson requests</div>
        <div className="csm-private-incoming">
          <span className="csm-private-incoming-label">From public site</span>
          <div className="csm-private-request-card">
            <div className="csm-avatar">EK</div>
            <div className="csm-private-details">
              <span className="csm-private-name">Emma Khan</span>
              <span className="csm-private-meta">Coach: Sarah · 8 sessions</span>
              <span className="csm-private-price">$640 package</span>
            </div>
          </div>
        </div>
        <div className="csm-private-inbox">
          <div className="csm-private-row csm-private-row--pending">
            <div className="csm-avatar">EK</div>
            <div className="csm-private-details">
              <span className="csm-private-name">Emma Khan</span>
              <span className="csm-private-meta">Tue · 4:00pm · 8 sessions</span>
            </div>
            <span className="csm-private-btn">Approve</span>
          </div>
        </div>
        <div className="csm-private-row csm-private-row--confirmed">
          <div className="csm-avatar">EK</div>
          <div className="csm-private-details">
            <span className="csm-private-name">Emma Khan</span>
            <span className="csm-private-meta">Tue · 4:00pm · 8 sessions</span>
          </div>
          <span className="csm-status csm-status--confirmed">Confirmed</span>
        </div>
        <div className="csm-private-payment-chip">Payment link ready</div>
      </div>
    </FeatureMockFrame>
  );
}
